module.exports = __webpack_public_path__ + "static/media/house.f45dc999.svg";